<template>
  <form @submit.prevent="submit">
    <FormMessage :errors="errors" v-if="errors" />
    <FormInput
      name="email"
      v-model="forgotPasswordFields.email"
      testId="email-input"
      :placeholder="$t('global.email')"
      :label="`${$t('global.email')} *`"
      :errors="validation.fields.email.errors"
      :dirty="validation.fields.email.dirty"
    />
    <div class="form-actions">
      <Btn
        variant="primary"
        type="submit"
        :disabled="loading"
        :loading="loading"
        @click="submit"
        data-test="reset-button"
      >
        {{ $t("global.reset") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import { reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import { forgotPassword as forgotPasswordRules } from "leatherman-js/utils/validations/forms";
import FormInput from "@/components/display/form/FormInput";
import FormMessage from "@/components/display/form/FormMessage";
import { fromServer } from "@/utils/translations";
import store from "@/store";
import useValidator from "@/utils/useValidator";

export default {
  name: "ForgotPasswordForm",
  components: {
    Btn,
    FormInput,
    FormMessage,
  },
  setup(props, { emit, root }) {
    // display variables
    const loading = ref(false);
    const errors = ref(null);

    // login variables and validation
    const forgotPasswordFields = reactive({
      email: null,
    });
    const { validator } = useValidator();
    const validation = validator(
      forgotPasswordFields,
      forgotPasswordRules,
      {},
      {
        email: {
          required: root.$t("validation.email-required"),
          email: root.$t("validation.invalid-email"),
        },
      }
    );

    // submit the form
    const submit = () => {
      errors.value = null;

      validation.validate().then(() => {
        loading.value = true;
        store
          .dispatch("auth/forgotPassword", forgotPasswordFields.email)
          .then(() => {
            emit("success");
          })
          .catch((e) => {
            errors.value = fromServer(e.request.response);
          })
          .finally(() => {
            loading.value = false;
          });
      });
    };

    return {
      errors,
      forgotPasswordFields,
      loading,
      submit,
      validation,
    };
  },
};
</script>

<style lang="scss" scoped></style>
